import React, { useEffect, useState } from "react";
import { TrendUp, MusicNote, Fire, ArrowUpRight } from "@phosphor-icons/react";
import { api } from "../lib/api";

const NICHES = [null, "ai", "finance", "gaming", "fitness", "tech", "motivation", "storytelling"];

export default function Trends() {
  const [topics, setTopics] = useState([]);
  const [audio, setAudio] = useState([]);
  const [filter, setFilter] = useState(null);

  useEffect(() => {
    const params = filter ? { niche: filter } : {};
    api.get("/trends/topics", { params }).then(r => setTopics(r.data));
  }, [filter]);

  useEffect(() => {
    api.get("/trends/audio").then(r => setAudio(r.data));
  }, []);

  return (
    <div className="p-6 md:p-10 max-w-7xl mx-auto" data-testid="trends-page">
      <p className="text-[#FF3B6B] text-sm font-mono">// TREND RADAR</p>
      <h1 className="text-3xl md:text-4xl font-bold tracking-tighter mt-2">What's blowing up right now</h1>

      <div className="mt-8 flex flex-wrap gap-2">
        {NICHES.map((n) => (
          <button key={n || "all"} onClick={() => setFilter(n)} className={`px-4 py-1.5 rounded-full text-xs capitalize transition-all ${filter === n ? "bg-[#FF3B6B] text-white" : "bg-white/5 border border-white/10 text-white/70 hover:bg-white/10"}`} data-testid={`trend-filter-${n || "all"}`}>
            {n || "All"}
          </button>
        ))}
      </div>

      <div className="mt-6 grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 space-y-3">
          <h2 className="text-lg font-semibold flex items-center gap-2"><Fire className="text-[#FF3B6B]" weight="fill" /> Trending topics</h2>
          {topics.map((t) => (
            <div key={t.id} className="glass rounded-xl p-5 hover:border-white/30 transition-all" data-testid={`trend-topic-${t.id}`}>
              <div className="flex items-start justify-between gap-4">
                <div className="flex-1">
                  <h3 className="font-medium text-lg">{t.topic}</h3>
                  <div className="mt-1 flex flex-wrap items-center gap-3 text-xs text-white/50">
                    <span className="capitalize px-2 py-0.5 bg-white/5 rounded">{t.niche}</span>
                    <span className="capitalize">{t.platform}</span>
                  </div>
                </div>
                <div className="text-right shrink-0">
                  <div className="flex items-center gap-1 text-[#00E5FF] font-mono text-sm font-bold">
                    <ArrowUpRight size={14} weight="bold" /> {t.growth}%
                  </div>
                  <div className="font-mono text-xs text-white/50 mt-1">Score {t.viral_score}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="space-y-3">
          <h2 className="text-lg font-semibold flex items-center gap-2"><MusicNote className="text-[#EAB308]" weight="fill" /> Trending audio</h2>
          {audio.map((a) => (
            <div key={a.id} className="glass rounded-xl p-4 hover:border-white/30 transition-all" data-testid={`trend-audio-${a.id}`}>
              <p className="font-medium">{a.title}</p>
              <div className="mt-1 flex items-center justify-between text-xs">
                <span className="text-white/50 capitalize">{a.vibe}</span>
                <span className="font-mono text-[#EAB308]">{a.uses} uses</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
